export default {
  message: {
    noData: "No data available",
  },
  header: {
    home: "Home",
    anchor: "Anchor",
    schedule: "Schedule",
    news: "News",
    subscribe: "Subscribe",
    download: "Download",
    apply_anchor: "Apply Anchor",
    login: "Login",
    register: "Register",
    personal_center: "Personal Center",
    logout: "Logout",
  },
  footer: {
    pro_anchor_exclusive: "Professional Anchor · Exclusive Events",
    global_events: "Global Events",
    hd_live: "HD Live",
    pro_anchor: "Professional Anchor",
    massive_data: "Massive Data",
    user_agreement: "User Agreement",
    privacy_policy: "Privacy Policy",
    disclaimer: "Disclaimer",
    permission_details: "Permission Details",
    ios_download: "IOS Download",
    android_download: "Android Download",
    qr_code: "QR Code",
  },
  downloadTip: {
    online_service: "Online Service",
    download: "Download",
    qr_code: "QR Code",
    download_app: "Download APP",
    more_live: "More Live Matches",
    cooperation: "Cooperation",
    no_content: "No related content yet, stay tuned!",
  },
  findPassword: {
    title: "Retrieve Password",
    input_phone: "Please enter your phone number",
    input_code: "Please enter the verification code",
    input_password: "Please enter your password",
    code_empty: "Verification code cannot be empty",
    get_code: "Get Code",
    resend: "Resend ({second})",
    get_code_success: "Verification code sent successfully",
    phone_warn: "Please enter a valid phone number",
    pass_warn: "Password must be 6-20 letters and numbers!",
    find_now: "Retrieve Now",
    success: "Password changed successfully, please log in again!",
  },
  register: {
    title: "Register",
    input_phone: "Please enter your phone number",
    input_code: "Please enter the verification code",
    input_password: "Please enter a 6-20 letter and number password",
    code_warn: "Please enter a valid verification code",
    pass_warn: "Please enter a 6-20 letter and number password",
    go_login: "Go to Login",
    register_and_login: "Register and Login",
    get_code: "Get Code",
    resend: "Resend ({second})",
    get_code_success: "Verification code sent successfully, please check",
    phone_warn: "Please enter a valid phone number",
    login_success: "Login successful",
  },
  mainTain: {
    img_alt: "Image",
    system_maintain: "System under maintenance...",
    maintain_words:
      "To serve you better, our website is currently being upgraded and maintained. We apologize for any inconvenience caused.",
  },
  login: {
    title: "Login",
    input_phone: "Please enter your phone number",
    input_password: "Please enter your password",
    register_now: "Register Now",
    forget_password: "Forgot Password",
    login_btn: "Login",
    phone_warn: "Please enter a valid phone number",
    pass_warn: "Password must be 6-20 letters and numbers!",
    phone_empty: "Please enter your phone number",
    pass_empty: "Please enter your password",
    login_success: "Login successful",
    pass_error: "Incorrect password!",
  },
  livingRank: {
    gold_anchor: "Gold Anchor",
    anchor_recommend: "Anchor Recommendation",
    change_batch: "Change Batch",
    subscribe: "Subscribe",
    subscribed: "Subscribed",
  },
  introduceLive: {
    live_recommend: "Live Recommendation",
    recommend: "Recommend",
    足球: "Football",
    篮球: "Basketball",
    电竞: "E-sports",
    网球: "Tennis",
    排球: "Volleyball",
    乒乓球: "Table Tennis",
    羽毛球: "Badminton",
    板球: "Cricket",
    搏击: "Combat Sports",
    其他: "Others",
    icon_alt: "Icon",
  },
  tipBox: {
    success: "Operation successful",
    login_success: "Login successful",
  },
  video: {
    enterStudio: "Enter Studio",
    danmu: "Danmu",
    loading: "Loading...",
    download_app: "Download APP",
    more_live: "More live matches",
    more_video: "More match videos",
    link_failed: "Link failed, please reload",
    reload: "Reload",
    danmu: "Danmu",
    enter_live: "Enter Live Room",
    drag_tip: "Hold the video to drag",
    click_pause: "Click to pause",
    click_play: "Click to play",
    click_mute: "Click to mute",
    cancel_mute: "Cancel mute",
    click_fullscreen: "Click to fullscreen",
    exit_fullscreen: "Exit fullscreen",
    load_error: "Load error",
  },
  home: {
    announcement: "Announcement",
    match_recommend: "Match Recommendation",
    icon_alt: "Icon",
    living: "Live",
    book_now: "Book Now",
    ended: "Ended",
    match_ended: "The match has ended!",
    coming_soon: "Coming Soon!",
    not_started: "Not Started",
    delayed: "Delayed",
    deleted: "Deleted",
  },
  myLiving: {
    my_live: "My Live",
    subscribe: "Subscribe",
    exit_live: "Exit Live",
    tips: "Tips",
    obs_tip:
      'Use OBS or other third-party live software to stream. Click "Start Live" after pushing successfully.',
    push_url: "Push URL",
    stream_name: "Stream Name",
    copy: "Copy",
    start_live: "Start Live",
    live_notice: "Live Notice",
    contact_us: "Contact Us",
    copy_success: "Copied successfully, go contact the anchor!",
    copy_address_success: "Address copied successfully",
    edit_notice_tip: "You can edit the live info after starting the live",
  },
  advisory: {
    related: "Related Articles",
    recommend: "Recommended News",
    more: "More",
  },
  competition: {
    nav_0: "Hot Matches",
    nav_1: "All Matches",
    nav_2: "My Reservations",
    all_matches: "All Matches",
    kill: "Kill",
    economy: "Economy",
    tower: "Tower",
    dragon: "Dragon",
    odds: "Odds",
    analysis: "Analysis",
    ended: "Ended",
    not_started: "Not Started",
    delayed: "Delayed",
    deleted: "Deleted",
    match_num: "Match {num}",
    week: "Week",
    today: "Today",
    loading: "Loading more data...",
    no_more_data: "No more data",
  },
  download: {
    scan_tip: "Scan to download Sports Live APP",
    ios_download: "Download for iOS",
    android_download: "Download for Android",
    android_download2: "Download for Android",
    ios_guide: "View iOS installation guide",
    global_matches: "Global Matches",
    hd_live: "HD Live",
    pro_live: "Professional Live",
    mass_data: "Massive Data",
  },
  giftItem: {
    send_gift: "sent {gift}",
  },
  live: {
    recommend: "Recommend",
    推荐: "Recommend",
    足球: "Football",
    篮球: "Basketball",
    电竞: "E-sports",
    网球: "Tennis",
    排球: "Volleyball",
    乒乓球: "Table Tennis",
    羽毛球: "Badminton",
    板球: "Cricket",
    搏击: "Combat Sports",
    全部: "All",
    其他: "Others",
    icon_alt: "Icon",
    loading: "Loading...",
    no_more: "No more data",
    load_more: "View more",
  },
  liveChat: {
    enter_room: "entered the chat room",
    anchor_offline: "The anchor is offline, unable to send messages",
    room_closed: "Chat room is closed",
    input_tip: "Please enter up to 30 characters...",
    please: "Please",
    login: "Login",
    send: "Send",
    new_msg: "{num} new messages",
    welcome: "Welcome ",
    iknow: "I know",
    muted_tip: "You have been muted, please contact the administrator!",
    force_offline:
      "You have been forced offline, please contact customer service!",
    muted: "Muted",
    cleared: "Chat messages have been cleared",
    room_closed_try: "Chat room is closed, please try again later!",
    loading: "Chat data is loading, please wait!",
    input_empty: "Please enter a message!",
    room_opened: "Chat room is open",
  },
  liveDetails: {
    resting: "The anchor is resting…",
    sports_live: "Sports Live",
    share: "Share",
    share_tip: "Invite friends to watch together",
    copy: "Copy",
    mobile_watch: "Watch on mobile",
    download_app_anytime: "Download the APP anytime, anywhere",
    free_watch: "Watch live matches for free",
    qr_alt: "QR code",
    people: "",
    subscribe: "Subscribe",
    subscribed: "Subscribed",
    anchor_offline: "The anchor is offline",
    recommend_live: "Recommended live for you",
    subscribe_tip: "Subscribe to get live reminders",
    icon_alt: "Icon",
    live_notice: "Live Notice",
    welcome: "Welcome to {name}'s live room",
    contact_us: "Contact Us",
    qq_wechat: "qq/wechat",
    push_order: "Anchor Push Order",
    push_order_list: "Push Order List",
    follow: " following",
    oppose: " against",
    combo: "Combo",
    give: "Send",
  },
  liveSettingDialog: {
    title: "Live Settings",
    live_title: "Live Title",
    live_category: "Live Category",
    service_select: "Customer Service",
    cover_upload: "Cover Upload",
    cover_tip:
      "Recommended cover size is 2MB. If not uploaded, a random screenshot will be used.",
    live_notice: "Live Notice",
    relate_title: "Related Match Data Analysis",
    just_live: "Just Go Live",
    relate_live: "Go Live with Match Data",
    not_started: "Not Started",
    in_progress: "In Progress",
    team_logo: "Team Logo",
    contact_title: "Contact Info",
    qq_number: "Number",
    qq_placeholder: "Please enter the QQ number you want to add",
    show_status: "Show Status",
    hide_all: "Hide All",
    show_all: "Show All",
    show_copy: "Show Copy Button",
    close: "Close",
  },
  personal: {
    account: "Account",
    go_live: "Go Live",
    push_order: "Push Order",
    account_setting: "Account Setting",
    base_info: "Basic Info",
    change_avatar: "Change Avatar",
    change_password: "Change Password",
    change_skin: "Change Skin",
    my_social: "My Social",
    my_follow: "My Follow",
    my_fans: "My Fans",
    my_room: "My Room",
    my_live_room: "My Live Room",
    my_live_record: "My Live Record",
    diamond: "Diamond",
    tip: "Tip",
    switch_skin_tip: "Switch to {skin} skin?",
    cancel: "Cancel",
    confirm: "Confirm",
    unmute_tip: "Confirm to unmute this user?",
    save: "Save",
    upload_avatar: "Upload Avatar",
    only_support: "(Only jpg, jpeg, png supported)",
    keep: "Save",
    cancel_follow: "Unfollow",
    subscribe: "Subscribe",
    unsubscribe: "Unsubscribe",
    search: "Search",
    start_time: "Start Date",
    end_time: "End Date",
    query_time: "Query Time",
    live_title: "Live Title",
    live_type: "Live Type",
    live_start: "Start Time",
    live_end: "End Time",
    live_people: "People",
    live_diamond: "Diamond",
    live: "Normal Live",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    please_input: "Please input",
    please_input_nickname: "Please input nickname",
    please_input_signature: "Please input signature",
    please_input_birthday: "Please input birthday",
    please_input_password: "Please input current password",
    please_input_new_password: "Please input new password",
    please_input_confirm_password: "Please input confirm password",
    please_input_avatar: "Please upload the avatar to change",
    please_input_sign: "Please input signature",
    please_input_room: "Please input room number",
    please_input_query: "Please input query",
    gender_secret: "Secret",
    gender_male: "Male",
    gender_female: "Female",
    nickname: "Nickname",
    gender: "Gender",
    signature: "Signature",
    birthday: "Birthday",
    save_success: "Saved successfully",
    save_fail: "Save failed",
    upload_success: "Avatar uploaded successfully",
    upload_fail: "Avatar upload failed, please try again",
    password_success: "Password changed successfully",
    password_fail: "Password must be 6-20 letters and numbers!",
    password_not_match:
      "New password and confirm password do not match, please re-enter",
    empty: "No data",
    unmute: "Unmute",
    status: "Status",
    operation: "Operation",
    anchor_name: "Anchor Name",
    processed_user: "Processed User",
  },
  pushOrder: {
    list: "Push Order List",
    add: "Add Push Order",
    id: "Push ID",
    category: "Category",
    select_category: "Please select category",
    status: "Status",
    select_status: "Please select status",
    desc: "Description",
    input_desc: "Please enter description",
    buy: "Buy",
    oppose: "Oppose",
    operate: "Action",
    edit: "Edit",
    delete: "Delete",
    confirm_delete: "Are you sure to delete this record?",
    reset: "Reset",
    search: "Search",
    searching: "Searching",
    submit: "Submit",
    submitting: "Submitting",
  },
  subscription: {
    living_now: "Live Now",
    not_live: "Not Live Yet",
    please_login: "Please login first!",
    login: "Login",
    no_subscribe_live: "No subscribed live, subscribe now!",
    no_subscribe_anchor: "No subscribed anchor, subscribe now!",
  },
};



// WEBPACK FOOTER //
// ./src/lang/en.js